export class LiveVendorData {
    _id?: string;
    zanders_available_qty: string;
    rsr_group_available_qty: string;
    chattanooga_available_qty: string;
    lipseys_available_qty: string;
    davidsons_available_qty: string;
    allen_arms_available_qty: string;
    manufacturer: string;
    mfg_part_number: string;
    upc: string;
    item_number: string;
    zanders_price: string;
    rsr_group_price: string;
    chattanooga_price: string;
    lipseys_price: string;
    davidsons_price: string;
    allen_arms_price: string;
    msrp: string;
    map_price: string;
    category: string;
    subcategory?: string;
    item_type?: string;
    desc1: string;
    desc2: string;
    weight: string;
    origin?: string;
    imageSource?: string;
    attributes?: Record<string, any>;
  }